import { useEffect } from "react";
import { tokenStore, fetchMe } from "@/lib/apiClient";

// Landing point for the central login app: stores the gateway token it put
// in the URL fragment, then does a full load so the app bootstraps signed in.
export default function SsoCallback() {
  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.replace(/^#/, "")).get("token");
    if (token) {
      try { sessionStorage.setItem("hv_sso_cb", String(Date.now())); } catch { /* ignore */ }
      tokenStore.set(token);
      // A plan that doesn't include this app (e.g. the free year has ended) is answered with 402. The front page would look
      // signed-out, so go to /login instead, which explains it (see ExternalLogin). Anything else carries on as before.
      fetchMe()
        .then(() => "/")
        .catch((e) => (e?.response?.status === 402 ? "/login" : "/"))
        .then((to) => window.location.replace(to));
    } else {
      window.location.replace("/login");
    }
  }, []);
  return null;
}
